import { defineStore } from 'pinia';

import type { Vendor } from '@stuut/api/models';

import { stuut } from '@/api';

interface State {
  initLoad: boolean;
  vendors: Vendor[];
}

export const useVendorStore = defineStore('vendors', {
  actions: {
    async getVendors() {
      const vendors = await stuut.vendors.list();

      this.$patch({ vendors });

      return this.vendors;
    },

    async setup() {
      if (this.vendors?.length || this.initLoad) return;

      this.initLoad = true;

      const vendors = await this.getVendors();

      return vendors;
    },
  },

  getters: {
    getById: (state) => {
      return (id: string) => state.vendors.find((vendor) => vendor?.id === id);
    },
  },

  state: (): State => ({
    initLoad: false,
    vendors: [],
  }),
});

export default useVendorStore;
